import urlParser from 'js-video-url-parser';
import type { VideoInfo } from 'js-video-url-parser/lib/urlParser';
import React from 'react';

interface Props {
  isCustomVideo: boolean;
  url: string;
}
const IframePlayer: React.FC<Props> = ({ isCustomVideo, url }) => {
  const embedUrl = isCustomVideo
    ? url
    : urlParser.create({
        videoInfo: urlParser.parse(url) as VideoInfo,
        format: 'embed',
      });

  return (
    <iframe
      data-hook="video-ssr-viewer"
      title="ricos-video"
      style={{ width: '100%' }}
      allow={'fullscreen'}
      src={embedUrl}
      allowFullScreen
      loading="lazy"
    />
  );
};

export default IframePlayer;
